import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as Actions from "../../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import { DefaultModality } from 'amazon-chime-sdk-js';
import moment from "moment"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { isChrome, isFirefox, isSafari, isMobileSafari } from "react-device-detect";

const ExerciseProgram = props => {
    const dispatch = useDispatch()

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownOpen2, setDropdownOpen2] = useState(false);
    const [Type, setType] = useState(1);

    const [VideoData, setVideoData] = useState([
    ]);

    const SpecialBodyParts = useSelector(({ meeting }) => meeting.SpecialBodyParts);
    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const FavVideosList = useSelector(({ meeting }) => meeting.FavVideosList)
    const ClinicLibary = useSelector(({ meeting }) => meeting.ClinicLibary)
    const IsPatientHashMap = useSelector(({ meeting }) => meeting.IsPatientHashMap);
    const SelectedVideoForROM = useSelector(({ meeting }) => meeting.SelectedVideoForROM);
    useEffect(() => {
        dispatch(Actions.GettingCommonExercises())
        dispatch(Actions.GettingFavVideos())
        dispatch(Actions.GettingClinicLibary())

    }, [])

    useEffect(() => {
        return () => {
            DisableImage()
        }
    }, [])

    function DisableImage() {
        dispatch({
            type: Actions.SET_EXERCISE_VIDEO,
            payload: {
                show: false,
                poster: "",
                video: "",
                isROM: true,
            }
        })
        const EXERCISE = "EXERCISE"
        meetingSession?.audioVideo.realtimeSendDataMessage(EXERCISE, JSON.stringify({
            show: false,
            poster: "",
            video: "",
            isROM: true,
            // PatientLocalID,
        }), 100000)

    }


    const toggle = () => setDropdownOpen(prevState => !prevState);
    const toggle2 = () => setDropdownOpen2(prevState => {
        setDropdownOpen(false)
        return !prevState
    });

    return (
        <div className="ExerciseTab">
            <div className="SelectVideoFromHere">
                <h5>SEND VIDEO CLIP</h5>

                {
                    !dropdownOpen2 ? (
                        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                            <DropdownToggle caret>
                                Select a Program
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => {
                                    setDropdownOpen2(true)
                                    setType(1)
                                }}>Somatic Assessment Clips</ DropdownItem>
                                {
                                    FavVideosList?.length > 0 ? (
                                        <DropdownItem onClick={() => {
                                            setDropdownOpen2(true)
                                            setType(2)
                                        }}>
                                            My Library
                                        </ DropdownItem>
                                    ) : null
                                }
                                {
                                    ClinicLibary?.length > 0 ? (
                                        <DropdownItem onClick={() => {
                                            setDropdownOpen2(true)
                                            setType(3)
                                        }}>
                                            Clinic Library
                                        </ DropdownItem>
                                    ) : null
                                }
                                <DropdownItem onClick={() => {
                                    props.Search()
                                }}>Search Somatic Library <i className="fa fa-search"></i></ DropdownItem>

                            </DropdownMenu>
                        </Dropdown>
                    ) : (
                        <Dropdown isOpen={dropdownOpen2} toggle={toggle2}>
                            <DropdownToggle caret>
                                Select a Program
                            </DropdownToggle>
                            {
                                Type == 1 ? (
                                    <DropdownMenu>
                                        {
                                            SpecialBodyParts?.map((value, index) => {
                                                return (
                                                    <DropdownItem
                                                        onClick={() => {
                                                            setVideoData([])
                                                            dispatch(Actions.GetttingVideos(value.therapyCategoryId)).then((res) => {
                                                                setVideoData(res)
                                                            })
                                                        }}
                                                        key={index}> {value.categoryName}</ DropdownItem>

                                                )
                                            })
                                        }
                                    </DropdownMenu>
                                ) : null
                            }
                            {
                                Type == 2 ? (
                                    <DropdownMenu>
                                        {
                                            FavVideosList?.map((value, index) => {
                                                return (
                                                    <DropdownItem
                                                        onClick={() => {
                                                            setVideoData([])
                                                            dispatch(Actions.GetttingVideos(value.therapyCategoryId)).then((res) => {
                                                                setVideoData(res)
                                                            })
                                                        }}
                                                        key={index}> {value.categoryName}</ DropdownItem>

                                                )
                                            })
                                        }
                                    </DropdownMenu>
                                ) : null
                            }
                              {
                                Type == 3 ? (
                                    <DropdownMenu style={{ height: '450px', overflowY: 'auto' }}>
                                        {
                                            ClinicLibary?.map((value, index) => {
                                                return (
                                                    <DropdownItem
                                                        onClick={() => {
                                                            setVideoData([])
                                                            dispatch(Actions.GetttingVideos(value.therapyCategoryId)).then((res) => {
                                                                setVideoData(res)
                                                            })
                                                        }}
                                                        key={index}> {value.categoryName}</ DropdownItem>

                                                )
                                            })
                                        }
                                    </DropdownMenu>
                                ) : null
                            }
                        </Dropdown>
                    )
                }

            </div>
            <div style={{ display: isSafari ? "block" : "flex", paddingLeft: isSafari ? "10px" : "0px" }} className="Video-List">
                {
                    VideoData ? VideoData.map((value, index) => {
                        return (
                            <span
                                key={index}
                                onClick={() => {
                                    dispatch({
                                        type: Actions.SET_EXERCISE_VIDEO,
                                        payload: {
                                            show: true,
                                            poster: `https://dfi4wfwfroz6l.cloudfront.net/${value.image}`,
                                            video: `${!parseInt(value.isInstalled) ? "https://d1rctz31urrh7u.cloudfront.net/" : "https://d3i9v5bkcvmkzb.cloudfront.net/"}${!parseInt(value.isInstalled) ? value.filename.replace(".mp4", "_1024.mp4") : value.filename}`,
                                        }
                                    })
                                    let PatientLocalID = "";

                                    if (Object.keys(IsPatientHashMap).length > 0 && SelectedVideoForROM) {

                                        for (const key in IsPatientHashMap) {

                                            if (IsPatientHashMap[key]) {

                                                if (IsPatientHashMap[key].videoTile == SelectedVideoForROM) {

                                                    PatientLocalID = IsPatientHashMap[key].UserID
                                                }
                                            }
                                        }
                                    }
                                    const EXERCISE = "EXERCISE"
                                    meetingSession?.audioVideo.realtimeSendDataMessage(EXERCISE, JSON.stringify({
                                        show: true,
                                        poster: `https://dfi4wfwfroz6l.cloudfront.net/${value.image}`,
                                        video: `${!parseInt(value.isInstalled) ? "https://d1rctz31urrh7u.cloudfront.net/" : "https://d3i9v5bkcvmkzb.cloudfront.net/"}${!parseInt(value.isInstalled) ? value.filename.replace(".mp4", "_1024.mp4") : value.filename}`,
                                        PatientLocalID,
                                        CompleteLinkForVideo: `https://d1rctz31urrh7u.cloudfront.net/${value.filename.replace(".mp4", "_1024.mp4")}`
                                    }), 100000)
                                }}
                                className="VideoShow">
                                <img
                                    src={`https://dfi4wfwfroz6l.cloudfront.net/${value.image}`}
                                    className="ShowImg"
                                />
                                <h4 className="ImgName">
                                    {
                                        value.videoName
                                    }
                                </h4>
                            </span>
                        )
                    }) : (
                        <h2>No Videos Available</h2>
                    )
                }
            </div>
        </div>
    )
}

ExerciseProgram.propTypes = {
    Search: PropTypes.func.isRequired,
}

export default ExerciseProgram
